"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Recharge = function Recharge(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.856 10.512a.494.494 0 00-.576.404 5.26 5.26 0 01-5.196 4.36A5.257 5.257 0 015.208 12l1.112.552a.494.494 0 10.44-.888L4.58 10.58a.494.494 0 00-.664.224l-1.084 2.18a.498.498 0 00.444.716c.18 0 .356-.1.444-.276l.548-1.104a6.24 6.24 0 005.812 3.948 6.26 6.26 0 006.176-5.18.496.496 0 00-.4-.576zM16.876 5.776a.494.494 0 00-.664.224l-.564 1.136c-1.072-2.072-3.216-3.404-5.56-3.404A6.26 6.26 0 004.3 7.584a.494.494 0 00.268.648.55.55 0 00.192.04.499.499 0 00.456-.304 5.266 5.266 0 019.444-.576l-1.044-.52a.494.494 0 10-.44.888l2.18 1.084a.492.492 0 00.664-.224l1.084-2.18a.504.504 0 00-.228-.664z",
    fill: color
  }));
};
var _default = exports["default"] = Recharge;